import { isEmpty, isValidAbsoluteUrl } from '@libs/shared';
import { getSiteRouter } from './site';
import { SITE_ROUTER } from '~/constants';
import { h5JsApi } from './h5-jsapi';

/**
 * URL 是否在域名白名单内
 *
 * @param url
 */
const isUrlInWhiteList = (url: string) => {
    const { domain = [], link_domain = '' } = window.jdy_config?.domain_white_list || {};
    const domainWhiteList = new Set([window.location.host].concat(domain));

    const regex = /^(?:https?:)?\/\/([^\/]+)(?:\/.*)?$/;
    const matches = url.match(regex);

    if (matches) {
        const host = matches[1];
        return domainWhiteList.has(host!) || (link_domain && host?.endsWith(link_domain));
    }
    return false;
};

/**
 * 重定向 URL 校验，校验失败返回 403：
 *  绝对路径：域名白名单校验
 *  相对路径：前缀校验
 *
 * @param url
 */
export const getUrlByValidate = (url: string) => {
    if (isEmpty(url)) {
        return url;
    }

    // 判断 URL 是否为有效的绝对路径
    if (isValidAbsoluteUrl(url)) {
        // 校验 URL 是否在白名单内
        return isUrlInWhiteList(url) ? url : getSiteRouter(SITE_ROUTER.ERROR, '403');
    }
    // 相对路径，判断前缀是否为'/'
    return url.startsWith('/') ? url : '/' + url;
};

/**
 * 是否支持PDF预览
 *
 * @returns {boolean|*}
 */
export const isSupportPdf = () => {
    return typeof (navigator.mimeTypes as any)['application/pdf'] !== 'undefined';
};

/**
 * 设置页面标题
 *
 * @param title
 */
export const setPageTitle = (title: string) => {
    if (isEmpty(title)) {
        return;
    }
    h5JsApi.setPageTitle(title);
};

/**
 * 是否为模板外链
 */
export const isTemplateExternalLink = () => {
    return !!(window.jdy_access_token && window.jdy_access_type === 'app_template');
};
